import PaymentResultPage from "./PaymentResultPage";

export default PaymentResultPage;
